<script setup lang="ts">
import RoomieIcon from '@lahaus-roomie/roomie/src/components/RoomieIcon/index.vue'
import RoomieButton from '@lahaus-roomie/roomie/src/components/RoomieButton/index.vue'
import SearchIcon from '@lahaus-roomie/roomie/src/assets/icons/v2/search.svg'
import LocationAutocomplete from '@/components/BrandedV2/LocationAutocomplete/index.vue'
import useRealEstateSearch from '@/components/BrandedV2/RealEstateSearch/use-search'
import type { SuggestionClient } from '@/services/listingDataService/types/suggestion'
import type { FormSearchFiltersComponentModule } from '@/components/BrandedV2/FormSearchFilters/types'
import { LOCATION_TYPE_LIST } from '@/services/listingDataService/enums'

const emit = defineEmits(['filters-change', 'residential-complex-selected'])

const { t, locale } = useI18n()
const { $useLhId } = useNuxtApp()

const {
  searchTerm,
  selectedFilters,
  onSubmit,
  suggestionSelected,
  setNeighborhoodsBySuggestion,
  filtersChange
} = useRealEstateSearch('/venta/propiedades', emit)

const onSuggestionSelected = async (suggestion: SuggestionClient.Suggestion & { defaultSuggestion: boolean }) => {
  suggestionSelected(suggestion)
  if (suggestion.type !== LOCATION_TYPE_LIST.RESIDENTIAL_COMPLEX) {
    setNeighborhoodsBySuggestion(suggestion)
    if (!suggestion.defaultSuggestion) await filtersChange(selectedFilters.value as FormSearchFiltersComponentModule.Filters)
  }
}

</script>

<script lang="ts">
export default {
  name: 'HomeLocationSearchBar'
}
</script>

<template>
  <div class="location-search-bar">
    <form
      class="w-full flex flex-col md:flex-row gap-12 md:gap-4 items-center"
      @submit.prevent="onSubmit">
      <div class="w-full flex flex-row gap-4 items-center">
        <LocationAutocomplete
          v-model="searchTerm"
          class="location-search-bar__autocomplete"
          container-class="w-full grid grid-cols-5 gap-4"
          input-container-class="col-span-5"
          placeholder="Busca por ciudad, zona o nombre del proyecto"
          :country-code="locale"
          :min-chars="3"
          :data-attributes="{ dataLh: { P: 'home', Z: 'invierte_para_vivir' } }"
          @select="onSuggestionSelected" />
      </div>

      <RoomieButton
        id="search-filter"
        type="submit"
        class="search-filter-button"
        :data-lh-id="$useLhId({ P: 'home', Z: 'invierte_para_vivir', A: 'buscar', C: 'lupa' })"
        variant="accent">
        <span class="flex flex-row items-center justify-center gap-8 pointer-events-none">
          <span class="flex md:hidden">
            {{ t('search') }}
          </span>

          <RoomieIcon custom-styles="block w-24 h-24 text-pine-600">
            <SearchIcon />
          </RoomieIcon>
        </span>
      </RoomieButton>
    </form>
  </div>
</template>

<style src="./_index.scss" lang="scss"></style>
<i18n src="./i18n.json"></i18n>
